{
  "until": "{{prayer}} تک {{duration}}",
  "begin_focus": "فوکس شروع کریں",
  "add_task": "کام شامل کریں",
  "more_tasks": "+{{count}} مزید",
  "fajr_at": "فجر {{time}} بجے",
  "schedule_title": "آج",
  "plan_my_day": "میرا دن ترتیب دیں",
  "planning": "منصوبہ بن رہا ہے…",
  "suggested": "تجویز کردہ",
  "keep_plan": "منصوبہ رکھیں",
  "undo_plan": "واپس لیں",
  "plan_error": "ابھی منصوبہ نہیں بن سکا۔ دوبارہ کوشش کریں۔",
  "plan_empty": "ابھی منصوبہ بندی کے لیے کچھ نہیں — پہلے کوئی کام شامل کریں۔",
  "plan_settled": "سب کچھ پہلے ہی اپنی جگہ پر ہے۔",
  "view_list": "فہرست",
  "view_switch_aria": "فہرست اور دن کے منظر کے درمیان تبدیل کریں",
  "unassigned": "غیر طے شدہ",
  "assign_title": "نماز کا بلاک",
  "no_block": "کوئی بلاک نہیں",
  "assign_aria": "کسی نماز کے بلاک سے منسلک کریں",
  "open_schedule_aria": "آج کا شیڈول کھولیں",
  "focus_session_label": "{{block}} · فوکس",
  "block_hero": "{{prayer}} تک گہرا کام",
  "moments_away": "{{prayer}} بس چند لمحوں میں",
  "block_clear": "سب مکمل — {{prayer}} تک آرام کریں",
  "alhamdulillah": "الحمد للہ",
  "exit_hint": "خاموشی سے نکلنے کے لیے Esc دبائیں",
  "exit_hint_touch": "خاموشی سے نکلنے کے لیے ✕ دبائیں",
  "mark_done_aria": "کام مکمل کے طور پر نشان زد کریں",
  "quick_add_placeholder": "اس بلاک میں شامل کریں…",
  "focus_task_aria": "اس کام پر توجہ دیں"
}
